import { createAction, props } from '@ngrx/store'
import { ClockInClockOut, ClockInClockOutResponse } from './clockIn-clockOut.state'

// Load Attendances
export const loadAttendances = createAction(
  '[Attendances] Load Attendances',
  props<{
    range?: { fromDate: Date; toDate: Date }
    filter?: {
      leaveType?: string
      workStatus?: string
      userId?: string
      businessId?: string
      search?: string
    }
    pagination?: { page?: number; limit?: number }
  }>()
)

export const loadAttendancesSuccess = createAction(
  '[Attendances] Load Attendances Success',
  props<{
    totalPresentToday: number
    lateLoginsToday: number
    todayPlannedLeaves: number
    todayUnplannedLeaves: number
    absentToday: number
    employeeCount: number
    totalCount: number
    clockinclockouts: ClockInClockOutResponse[]
  }>()
)

export const loadAttendancesFailure = createAction(
  '[Attendances] Load Attendances Failure',
  props<{ error: string }>()
)

export const loadAttendanceCounts = createAction('[Attendance] Load Counts')
export const setAttendanceCounts = createAction(
  '[Attendance] Set Counts',
  props<{
    totalCount: number
    totalWorkHoursThisWeek: string
    totalWorkHoursThisMonth: string
    totalWorkHours: string
  }>()
)

// New action to get latest clock-in data after success
export const loadEmployeeAttendance = createAction(
  '[ClockInClockOut] Load Employee Attendance',
  props<{ id: string | undefined; params: string | null; page?: number; limit?: number }>()
)

export const loadEmployeeAttendanceSuccess = createAction(
  '[ClockInClockOut] Load Employee Attendance Success',
  props<{
    totalCount: number
    attendances: ClockInClockOutResponse[]
    totalWorkHoursThisWeek: string
    totalWorkHoursThisMonth: string
    totalWorkHoursToday: string
    totalProductiveWorkHoursToday: string
    totalBreakHoursToday: string
    todaysClockinoutRecords: ClockInClockOut[]
    expectedWorkHoursToday: string
    expectedWorkHoursThisWeek: string
    expectedWorkHoursThisMonth: string
    totalOvertimeToday: string
    totalOvertimeThisMonth: string
  }>()
)

export const loadEmployeeAttendanceFailure = createAction(
  '[ClockInClockOut] Load Employee Attendance Failure',
  props<{ error: any }>()
)

export const createClockInClockOut = createAction(
  '[ClockInClockOut] Create ClockInClockOut',
  props<{
    clockIn: Date
  }>()
)

export const createClockInClockOutSuccess = createAction(
  '[ClockInClockOut] Create ClockInClockOut Success',
  props<{
    clockInClockOut: ClockInClockOut
    // latestPunchIn: ClockInClockOut
  }>()
)

export const createClockInClockOutFailure = createAction(
  '[ClockInClockOut] Create ClockInClockOut Failure',
  props<{ error: any }>()
)

// New action to get latest clock-in data after success
export const getLatestClockIn = createAction(
  '[ClockInClockOut] Get Latest ClockIn',
  props<{ id: string }>()
)

export const getLatestClockInSuccess = createAction(
  '[ClockInClockOut] Get Latest ClockIn Success',
  props<{
    clockInClockOuts: ClockInClockOut
    isPunchedIn: boolean
    latestPunchIn: ClockInClockOut
  }>()
)

export const getLatestClockInFailure = createAction(
  '[ClockInClockOut] Get Latest ClockIn Failure',
  props<{ error: any }>()
)

export const updateClockIn = createAction(
  '[ClockInClockOut] Update ClockIn',
  props<{ id: string }>()
)

export const updateClockInSuccess = createAction(
  '[ClockInClockOut] Update ClockIn Success',
  props<{ clockInClockOut: ClockInClockOut }>()
)

export const updateClockInFailure = createAction(
  '[ClockInClockOut] Update ClockIn Failure',
  props<{ error: any }>()
)

export const clearAttendanceState = createAction('[ClockInClockOut] Clear State')

export const createEvent = createAction(
  '[ClockInClockOut] Create Event',
  props<{
    clockIn: Date
    workStatus: string
    lateLogin: string | null
    userId: string
    timeZone: string
  }>()
)

export const createEventSuccess = createAction(
  '[ClockInClockOut] Create Event Success',
  props<{
    clockInClockOut: ClockInClockOut
    // latestPunchIn: ClockInClockOut
  }>()
)

export const createEventFailure = createAction(
  '[ClockInClockOut] Create Event Failure',
  props<{ error: any }>()
)

export const clearLatestPunchIn = createAction('[ClockInClockOut] Clear Latest PunchIn')
